import Blog from "./blog/Blog";
const Home = () => {
    return (
        <div>
            <Blog className="card_blog"/>
        </div>
     )
}
 
export default Home;